/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-09-06 13:53:28
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-24 17:43:49
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  DatePicker,
  Checkbox,
  Input,
  Popover,
  notification,
} from 'antd'
import { unwatchFile } from 'fs'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTenantId, selectChainId, selectChainType } from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import { getChainTenantListFn } from '../../chainTransferApplication/chainSlice'
import { SupplierModal } from '../../savebusiness/modal'
import styles from './recentTimeDrugCollectionEfforts.module.css'
const { Option } = Select

export const Query = (props: {
  loading?: any
  exportLoading?: any
  onValueChange: (params: any) => void
  export: () => void
  print: () => void
}): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [flag, setFlag] = useState<any>()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const chainType = useSelector(selectChainType)

  const [chainList, setChainList] = useState<any>([])

  const [isModalVisible, setIsModalVisible] = useState(false)

  useEffect(() => {
    form.setFieldsValue({
      day: 180,
    })
  }, [])

  useEffect(() => {
    if (tenantId == chainId) {
      dispatch(getChainTenantListFn())
        .then(unwrapResult)
        .then((res: any) => {
          setChainList(res?.records)
        })
    }
  }, [])

  return (
    <>
      <Form
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
        autoComplete='off'
        form={form}
        onFinish={(values) => {
          props.onValueChange({
            ...values,
          })
        }}
      >
        <Row
          style={{ marginBottom: 10, width: '100%', height: '42px' }}
          align='middle'
          justify='space-between'
        >
          <Space>
            <Form.Item name='materialsName' noStyle>
              <Input
                style={{ width: '200px' }}
                allowClear={true}
                placeholder='商品名称'
                onChange={() => {
                  form.submit()
                }}
              />
            </Form.Item>
            <Form.Item name='day' noStyle>
              <Input
                type='number'
                style={{ width: '200px' }}
                allowClear={true}
                placeholder='提前多少天'
                onChange={(v:any) => {
                  if (Number(v?.target?.value) > 0) {
                    if (v?.target?.value == Math.floor(v?.target?.value)) {
                      form.submit()
                    } else {
                      notification.info({
                        message: '请输入大于0的正整数',
                      })
                    }
                  } else {
                    notification.info({
                      message: '请输入大于0的正整数',
                    })
                  }
                }}
              />
            </Form.Item>
            <Form.Item name='gysName' noStyle>
              <Input
                style={{ width: '200px' }}
                allowClear={true}
                placeholder='供应商'
                onChange={() => {
                  form.submit()
                }}
              />
              {/* <Input
                style={{ width: '150px' }}
                onChange={() => {
                  form.submit()
                }}
                placeholder='供应商'
                size='middle'
                allowClear
                onClick={() => {
                  setFlag(0)
                  setIsModalVisible(true)
                }}
              /> */}
            </Form.Item>
            <Form.Item name='category' noStyle>
              <Select
                style={{ width: '150px' }}
                placeholder='商品分类'
                allowClear
                onChange={() => {
                  form.submit()
                }}
              >
                <Select.Option value={'0'} key={'0'}>
                  药品
                </Select.Option>
                <Select.Option value={'2'} key={'2'}>
                  材料
                </Select.Option>
                <Select.Option value={'3'} key={'3'}>
                  器械
                </Select.Option>
                <Select.Option value={'4'} key={'4'}>
                  其他
                </Select.Option>
              </Select>
            </Form.Item>
            {(tenantId == chainId && chainType >= 0) ? (
            <Form.Item name='tenantId' noStyle>
              <Select
                placeholder={'选择门店'}
                allowClear
                showSearch
                dropdownClassName={styles.select}
                style={{ width: '16rem' }}
                optionFilterProp='children'
                onChange={form.submit}
              >
                {chainList?.map((v: any, i: any) => {
                  return (
                    <Option value={v.id} key={i}>
                      {v.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : (
            ''
          )}
            <Button
              loading={props?.loading}
              type='primary'
              onClick={() => {
                form.submit()
              }}
            >
              查询
            </Button>
          </Space>
          <Space>
            <Button
              loading={props?.exportLoading}
              type='primary'
              onClick={() => {
                props?.export && props?.export()
              }}
            >
              导出
            </Button>
            <Button
              loading={props?.exportLoading}
              type='primary'
              onClick={() => {
                props?.print && props?.print()
              }}
            >
              打印
            </Button>
          </Space>
        </Row>
      </Form>
      <SupplierModal
        supplierCategory={flag}
        visible={isModalVisible}
        switchModal={() => {
          setIsModalVisible(false)
          setFlag('')
        }}
        onOk={() => {
          setIsModalVisible(false)
          setFlag('')
        }}
        onCancel={() => {
          setIsModalVisible(false)
          setFlag('')
        }}
        onRecord={(record: any) => {
          form.setFieldsValue({
            gysName: record.companyName,
          })
          form.submit()
        }}
      />
    </>
  )
}
